exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".label i {\n\tvertical-align: middle;\n\tcursor: pointer;\n}\n\n.nm-reactive-select-labels {\n\tmargin-top: 5px;\n}\n\n.nm-reactive-select-labels-wrapper .label button {\n\tborder: 0;\n\tbackground: none;\n\tbackground-color: transparent;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n/*.nm-reactive-select-labels {\n\tposition: absolute;\n\ttop: 0;\n\tright: 12px;\n\tmax-width: 70%;\n\toverflow: auto;\n}\n\n.nm-reactive-select-labels-wrapper {\n\twhite-space: nowrap;\n}\n\n.nm-reactive-select-control-left {\n\tposition: absolute;\n\tleft: 0;\n}\n\n.nm-reactive-select-control-right {\n\tposition: absolute;\n\tright: 0;\n}*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/widgets/reactive-select/reactive-select.css
// module id = 452
// module chunks = 0